import styled from 'styled-components';

export const ModalTitle = styled.h1`
    color: var(--default-text-color);
    font-size: var(--modal-title-text-size);
    margin: 0;
    padding: 0;
`;

export const ModalLabel = styled.h2`
    color: var(--default-text-color);
    font-size: var(--modal-title-label-size);
    margin: 0 0 8px;
    padding: 0;
`;
